import { Grid, Typography, useTheme } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import { ToggleButtons } from "@aclymatepackages/atoms";
import { mergeDarkTheme, mainTheme } from "@aclymatepackages/themes";

import { useSurveyLanguage } from "../../helpers/contexts/surveyLanguage";

const TranslatedYesNoQuestionButtons = ({ value, setValue, disabled }) => {
  const { palette } = useTheme();
  const { translate } = useSurveyLanguage();

  const noButtonStyleObj =
    value === false ? { style: { backgroundColor: palette.error.main } } : {};

  const yesButtonStyleObj = value
    ? { style: { backgroundColor: palette.secondary.main } }
    : {};

  const buttons = [
    { value: false, name: translate("common.no"), ...noButtonStyleObj },
    { value: true, name: translate("common.yes"), ...yesButtonStyleObj }
  ];

  return (
    <ToggleButtons
      value={value}
      onChange={setValue}
      buttons={buttons}
      disabled={disabled}
    />
  );
};

const TranslatedYesNoQuestion = ({
  question,
  value,
  setValue,
  typographyProps,
  lightBackground,
  disabled
}) => {
  const findTheme = () => {
    if (lightBackground || value !== undefined) {
      return mainTheme;
    }

    return mergeDarkTheme;
  };

  return (
    <Grid
      container
      spacing={2}
      justifyContent="space-between"
      alignItems="center"
      wrap="nowrap"
    >
      <Grid item>
        <Typography
          variant="body1"
          color={lightBackground ? "textPrimary" : "inherit"}
          {...typographyProps}
        >
          {question}
        </Typography>
      </Grid>
      <Grid item>
        <ThemeProvider theme={findTheme()}>
          <TranslatedYesNoQuestionButtons
            value={value}
            setValue={setValue}
            disabled={disabled}
          />
        </ThemeProvider>
      </Grid>
    </Grid>
  );
};
export default TranslatedYesNoQuestion;
